import React, { useState, useEffect } from "react";
import "./AdminPanel.css";

const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchAllUsers();
  }, []);

  // Fetch all users
  const fetchAllUsers = async () => {
    try {
      const response = await fetch(
        "https://nesthub-server.vercel.app/api/member/"
      );
      const data = await response.json();
      setUsers(data.users);
    } catch (error) {
      setMessage("Failed to fetch users");
    }
  };

  // Fetch a single user by ID
  const fetchUserDetails = async (userId) => {
    try {
      const response = await fetch(
        `https://nesthub-server.vercel.app/api/member/${userId}`
      );
      const data = await response.json();
      setUserDetails(data.user);
    } catch (error) {
      setMessage("Failed to fetch user details");
    }
  };

  // Verify user
  const verifyUser = async (userId) => {
    try {
      const response = await fetch(
        `https://nesthub-server.vercel.app/api/member/verify/${userId}`,
        {
          method: "PUT",
        }
      );
      if (response.ok) {
        setMessage("User verified successfully");
        fetchAllUsers();
      } else {
        setMessage("Failed to verify user");
      }
    } catch (error) {
      setMessage("Failed to verify user");
    }
  };

  // Verify extra for user
  const verifyExtra = async (userId) => {
    try {
      const response = await fetch(
        `https://nesthub-server.vercel.app/api/member/extra/${userId}`,
        {
          method: "PUT",
        }
      );
      if (response.ok) {
        setMessage("Extra verification completed successfully");
        fetchAllUsers();
      } else {
        setMessage("Failed to verify extra");
      }
    } catch (error) {
      setMessage("Failed to verify extra");
    }
  };

  return (
    <div className="admin-panel">
      <h1 className="title">Admin Panel</h1>

      {message && <p className="message">{message}</p>}

      <h2 className="subtitle">All Users</h2>
      <ul className="user-list">
        {users.map((user) => (
          <li key={user._id} className="user-item">
            <span>
              {user.fullname} - {user.email}
            </span>
            <button
              className="btn verify-btn"
              onClick={() => verifyUser(user._id)}
            >
              Verify User
            </button>
            <button
              className="btn extra-btn"
              onClick={() => verifyExtra(user._id)}
            >
              Verify Extra
            </button>
            <button
              className="btn details-btn"
              onClick={() => fetchUserDetails(user._id)}
            >
              View Details
            </button>
          </li>
        ))}
      </ul>

      {userDetails && (
        <div className="user-details">
          <h3>User Details</h3>
          <p>Full Name: {userDetails.fullname}</p>
          <p>Email: {userDetails.email}</p>
          <p>Phone: {userDetails.phone}</p>
          <p>Verified: {userDetails.verified ? "Yes" : "No"}</p>
          <p>Extra Verified: {userDetails.extra ? "Yes" : "No"}</p>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
